// Marker that we can use to find invoice line items that are not associated
// with a trip so we can remove the trip from the upsert
export const INVOICE_LINE_ITEM_TRIP_ID_MARKER =
  'invoice-line-item-trip-id-marker';
